module.exports = __webpack_public_path__ + "img/target.4ca266e9.png";